import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

/**
 * `/` — root path. Always redirects: authenticated users land on the
 * dashboard; everyone else is bounced to /login by the authenticated route
 * group's guard.
 *
 * `verified` is coerced to a string because TanStack Router parses `?verified=1`
 * as the number 1 — a bare z.string() would throw an "invalid_type" error (the
 * original verify-link bug). The email-verify flow now redirects straight to
 * /login?verified=1, but we still forward any stray `?verified` on `/` (older
 * email links) to /login so the outcome is surfaced.
 */
const searchSchema = z.object({
  verified: z.coerce.string().optional(),
  error: z.string().optional(),
});

export const Route = createFileRoute("/")({
  validateSearch: searchSchema,
  beforeLoad: ({ search }) => {
    if (search.verified !== undefined) {
      throw redirect({ to: "/login", search: { verified: search.verified } });
    }
    throw redirect({ to: "/dashboard" });
  },
});
